import { render } from "./TableExpandable.vue?vue&type=template&id=1d5130b0"
import script from "./TableExpandable.vue?vue&type=script&lang=js"
export * from "./TableExpandable.vue?vue&type=script&lang=js"

import "./TableExpandable.vue?vue&type=style&index=0&id=1d5130b0&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__